// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/HomePage';
import ReviewPage from './pages/ReviewPage';
import About from './pages/AboutPage';
import Navbar from './components/Navbar';
import SearchPage from './pages/SearchPage';
import MyReviewPage from './pages/MyReviewPage';
import Footer from './components/Footer';
import NotFound from './pages/NotFound';
import MoviesPage from './pages/MoviesPage';
import TVShowsPage from './pages/TvShowsPage';
import GamePage from './pages/GamePage';
import GameDetails from './pages/GameDetails';

function App() {
  return (
    <Router>
      <Navbar />
      <main className="content-wrap">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/:mediaType/:id" element={<ReviewPage />} />
          <Route path="/my-reviews" element={<MyReviewPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/movies" element={<MoviesPage />} />
          <Route path="/tv-shows" element={<TVShowsPage />} />
          <Route path="/games" element={<GamePage />} />
          <Route path="/games/:id" element={<GameDetails />} />
          <Route path="*" element={<NotFound />} /> {/* Catch-all route */}
          {/* Add more routes as needed */}
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;